import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AtivitiesService } from '../../+activities/ativities.service';

@Component({
  selector: 'dialog-accept-task',
  templateUrl: './dialog-accept-task.component.html',
  styleUrls: ['./dialog-accept-task.component.css']
})
export class DialogAcceptTaskComponent implements OnInit {
  public loading: boolean;
  public title: string;
  public user: string;
  public comment: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogAcceptTaskComponent>,
    private activitiesService: AtivitiesService
  ) {
  }

  ngOnInit() {
    this.comment = '';

    this.title = this.data.data.properties.bpm_description;
    this.user = this.data.data.workflowInstance.initiator.firstName;
  }

  public accept() {
    const id = [
      this.data.data.id.toString().slice(0, 9),
      '24',
      this.data.data.id.toString().slice(9)
    ]
      .join('')
      .split('$')
      .join('%');

    const data: any = {
      prop_bpm_comment: this.comment,
      prop_imwf_reviewOutcome: 'approve',
      prop_transitions: 'Next'
    };
    this.activitiesService.acceptTask(id, data).then(res => {
      this.loading = false;
    });
  }

  public reject() {
    const id = [
      this.data.data.id.toString().slice(0, 9),
      '24',
      this.data.data.id.toString().slice(9)
    ]
      .join('')
      .split('$')
      .join('%');

    const data: any = {
      prop_bpm_comment: this.comment,
      prop_imwf_reviewOutcome: 'reject',
      prop_transitions: 'Next'
    };
    this.activitiesService.acceptTask(id, data).then(res => {
    });
  }
}
